import { TariffService } from './tariff';
import { TariffGroupType } from '../../schema';

export async function findAllGroups (): Promise<Array<TariffGroupType>> {
    return TariffService.findAllGroups();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/tariff/tariff.find-all-groups.ts